import React from 'react';
import { motion } from 'framer-motion';

const IndustriesServe = ({ data }) => {
    // Agar data nahi hai to render mat karo
    if (!data) return null;

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.1 }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, x: 20 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.5 } }
    };

    return (
        <section className="relative w-full py-20 lg:py-32 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <img src={data.backgroundImage} className='w-full object-cover' alt="Background" />
            </div>

            <div className="max-w-[1440px] mx-auto px-6 lg:px-[80px] relative z-10 flex flex-col lg:flex-row items-center gap-12 lg:gap-20">

                <motion.div
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    className="w-full lg:w-full max-w-[448px] text-white"
                >
                    <h2 className="text-[20px] lg:text-[30px] font-[600] font-sora mb-[20px] leading-[1.2]">
                        {data.heading}
                    </h2>
                    <p className="text-white text-[14px] md:text-[16px] leading-relaxed font-graphik font-[500] pr-0 lg:pr-10">
                        {data.description}
                    </p>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
                    className="w-full lg:w-7/12"
                >
                    <div className="bg-white p-8 lg:p-14 shadow-2xl">
                        <motion.div
                            variants={containerVariants}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true }}
                            className="grid grid-cols-1 md:grid-cols-2 gap-y-6 gap-x-8"
                        >
                            {data.industriesList.map((industry, index) => (
                                <motion.div key={index} variants={itemVariants} className="flex items-start gap-3">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 mt-0.5">
                                        <path d="M9 18L15 12L9 6" stroke="#ED6800" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    <span className="text-[#49577A] text-[14px] lg:text-[16px] font-[500] font-graphik leading-tight mt-0.5">
                                        {industry}
                                    </span>
                                </motion.div>
                            ))}
                        </motion.div>
                    </div>
                </motion.div>

            </div>
        </section>
    );
};

export default IndustriesServe;